import { Button, Stack, Typography } from "@mui/material";
import CustomDialog from "global/components/CustomDialog/CustomDialog";
import CustomLoader from "global/components/CustomLoader/CustomLoader";
import { handleErrorMessage } from "helpers/methods";
import { useState } from "react";
import { convertToManual } from "screens/Campaigns/CampaignService";

interface CustomProps {
  isDialogOpen: boolean;
  handleDialogClose: Function;
  campaignId: number;
  refresh: Function;
}

const SetManualDialog = (props: CustomProps) => {
  const [loading, setLoading] = useState<boolean>(false);

  const handleUpdateManualExecution = async () => {
    try {
      setLoading(true);
      await convertToManual(props?.campaignId);
      props.handleDialogClose();
      props.refresh();
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      handleErrorMessage(error);
    }
  };
  const getBody = () => {
    return (
      <>
        <Stack spacing={1}>
          <Typography variant="body2">
            By switching to manual, you’ll have to pick a campaign from the
            variant to be sent to the remaining audience.
          </Typography>
          <Typography variant="body2">
            Are you sure want to convert the A/B testing campaign execution type
            to manual?
          </Typography>
        </Stack>
      </>
    );
  };

  const getFooter = () => {
    return (
      <Stack direction="row" spacing={1}>
        <Button
          variant="outlined"
          size="small"
          onClick={() => {
            props.handleDialogClose();
          }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          size="small"
          disabled={loading}
          onClick={handleUpdateManualExecution}
        >
          Update
        </Button>
      </Stack>
    );
  };
  return (
    <>
      <CustomDialog
        handleDialogClose={props.handleDialogClose}
        isDialogOpen={props.isDialogOpen}
        body={getBody()}
        footer={getFooter()}
        title={
          <Typography variant="h4" color="#7551D0">
            Convert to manual execution{" "}
          </Typography>
        }
        closeButtonVisibility
        closable
      />
      <CustomLoader isLoading={loading} />
    </>
  );
};

export default SetManualDialog;
